import useApiQuery from '@hooks/useApiQuery';
import moment from 'moment';
import { useState } from 'react';

export interface ExportFileConfig {
  endpoint: string;
  entityName: string;
}

export default function useExportFile(config: ExportFileConfig) {
  const [exportKey, setExportKey] = useState<string>('');

  const customFilename = exportKey
    ? `${config.entityName}_${exportKey}`
    : config.entityName;

  const query = useApiQuery<Response>({
    queryKey: ['export', config.entityName, config.endpoint, exportKey],
    apiPath: `/${config.endpoint}`,
    method: 'GET',
    isFile: true,
    useV2API: true,
    enabled: !!exportKey,
    customFilename,
  });

  const exportFile = (): boolean => {
    const dateTime = moment().format('MM-DD_HH-mm-ss');
    setExportKey(dateTime);
    return true;
  };

  return {
    exportFile,
    isExporting: query.isFetching || query.isLoading,
    error: query.error as Error | null,
  };
}
